module.exports = __webpack_public_path__ + "static/media/monelevage-logo-1024x1024-white.68ea3840.svg";